const locale = {
    placeholder: 'वेळ निवडा',
    rangePlaceholder: ['सुरुवातीचा वेळ', 'समाप्तीचा वेळ'],
};
export default locale;
